import React from 'react'
import MaterialTextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'

class Component extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <MaterialTextField
                InputLabelProps={{
                    shrink: true,
                }}
                margin="dense"
                fullWidth
                inputProps={
                    this.props.readOnly && {
                        readOnly: true,
                        style: { textAlign: 'center' },
                    }
                }
                variant={this.props.readOnly && 'outlined'}
                {...this.props}
            />
        )
    }
}

Component.propTypes = {
    readOnly: PropTypes.bool,
}

export const TextField = Component
